import React, { useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";

const Fileupload = ({
  file,
  setFiles,
  setSelectedData,
  category,
  setFileName,
  emptyFile,
}) => {
  const [dragging, setDragging] = useState(false);
  const [inputFiles, setInputFiles] = useState({
    name: "",
    size: "",
    content: "",
  });
  const fileInputRef = useRef(null);
  const [encrypted, setencrypted] = useState("");

  const handleDragOver = (e) => {
    e.preventDefault();
    setDragging(true); // Highlight the area when dragging files
  };

  useEffect(() => {
    if (setSelectedData) {
      setSelectedData((prev) => ({
        ...prev,
        filename: inputFiles.name,
        content: inputFiles.content,
        file_process:
          category === "1"
            ? "xml_to_dita"
            : category === "2"
            ? "word_to_dita"
            : category === "5"? "wordtb_to_dita"
             : category === "6"? "wordim_to_dita"
             :category === "8"? "wordq&a_to_dita"        
            : category === "4"? "xml_to_html"
            : category ==="9"? "castoff": "excel_to_dita",
      }));
    } else {
      if (setFiles) {
        setFiles(inputFiles.content);
      }
      if (setFileName) {
        setFileName(inputFiles.name);
      }
    }
  }, [inputFiles]);

  const handleClick = (e) => {
    e.preventDefault();
    fileInputRef.current.click();
  };

  // console.log(inputFiles);

  const handleDragLeave = () => {
    setDragging(false); // Remove highlight when leaving
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setDragging(false); // Remove highlight when dropping files
    const files = e.dataTransfer.files;
    handleFiles(files); // Handle dropped files
  };



  const downloadFile = () => {
    // Files in public folder can be accessed directly with /filename
    const url = `/sample.zip`; // example: /myfile.zip
  
    if (url) {
      const link = document.createElement("a");
      link.href = url;
      link.download = "sample.zip"; // the downloaded file will have this name
      document.body.appendChild(link); // for Firefox support
      link.click();
      document.body.removeChild(link);
  

    } else {
      toast.info("No Files to Download");
    }
  };
  

  const handleFiles = (files) => {
    // Reset inputFiles if needed
    setInputFiles("");

    if (files && files[0]) {
      const file = files[0]; // Get the first file
      const { name, size } = file;

      const reader = new FileReader();

      reader.onloadend = () => {
        // Update the state with content, name, and size after reading is complete
        setInputFiles((prev) => ({
          ...prev,
          content: reader.result, // Base64 content of the file
          name: name,
          size: size,
        }));
      };

      // Start reading the file as a Data URL
      reader.readAsDataURL(file);
    }
  };

  useEffect(() => {
    if (emptyFile === 1) {
      setInputFiles({
        name: "",
        size: "",
        content: "",
      });
    }
  }, [emptyFile]);

  return (
    <div className="w-full">
      <div
        className="flex w-full bg-white border-[1px] border-commonborder p-6 rounded-[24px]"
        onDragOver={handleDragOver}
        onDragLeave={handleDragLeave}
        onDrop={handleDrop}
      >
        {dragging ? (
          <div className="flex bg-commonfill min-h-[200px] w-full justify-center items-center flex-col">
            <div className="w-auto h-auto mb-6">
              <img
                src={process.env.PUBLIC_URL + "/images/dropfilelogo.png"}
                alt="icon"
              />
            </div>
            <p className="text-8C8A9B">Drop your files here</p>
          </div>
        ) : (
          <div className="bg-commonfill border-[1px] border-highlight border-dashed py-12 flex flex-col justify-center w-full items-center rounded-[16px]">
            <div className="w-auto h-auto mb-6">
              <img
                src={process.env.PUBLIC_URL + "/images/dropfilelogo.png"}
                alt="icon"
              />
            </div>
            <h1 className="text-18">
              Drag and Drop files here or{" "}
              <button
                onClick={(e) => handleClick(e)}
                className="text-18 text-154A79 font-semibold underline underline-offset-2 text-highlighttext"
              >
                Choose file
              </button>
            </h1>
            <input
              type="file"
              name="project_name"
              placeholder="Enter Project Name"
              ref={fileInputRef}
              style={{ display: "none" }} // hide the file input
              multiple
              onChange={(e) => {
                handleFiles(e.target.files);
              }}
              onClick={(e) => (e.target.value = null)}
              accept={
                category === "1" ||  category === "4" 
                  ? ".xml"
                  : category === "3"
                  ? ".xlsx, .xls"
                  : category === "5" || category==="6" || category === "9"
                  ? ".zip,application/zip,application/x-zip-compressed"
                  : category === "2" || category==="8"
                  ? ".docx"
                  : ".epub"
              }
            />
            <div className="mt-3">
              <p className="text-8C8A9B">{`Supported formats: ${
                category === "1" || category === "4"
                  ? ".xml file"
                  : category === "3"
                  ? ".xls or .xlsx file"
                  : category === "5" || category==="6" || category === "9"
                  ? ".zip"
                  : category === "2" || category==="8"
                  ? ".docx"
                  : ".epub file"
              }`}</p>
            </div>
            {
              category === "9" &&(
                <button className="text-sm mt-2 text-blue-500" onClick={()=>{downloadFile()}}>
                  Download Sample Input
                </button>
              )
            }
          </div>
        )}
      </div>
      {inputFiles && inputFiles.name?.length > 0 && (
        <div className="w-full max-h-fit mt-6 bg-white overflow-hidden rounded-[12px]">
          <div className="p-6 border-[1px] border-C4C6CC rounded-[12px]  bg-F8F9FA">
            <div className="bg-commonfill border-[1px] border-highlight py-4 flex flex-col justify-center w-full items-center rounded-[16px]">
              <div className="flex w-full px-4 items-center justify-between">
                <div className="flex items-center justify-between gap-4">
                  <span className="w-8 h-8">
                    <img
                      alt="epub_logo"
                      src={process.env.PUBLIC_URL + "/images/epub.svg"}
                      className="w-full h-full object-cover"
                    ></img>
                  </span>
                  <div className="flex flex-col items-start">
                    <p>{inputFiles !== undefined ? inputFiles.name : ""}</p>
                    <p className="text-8C8A9B">
                      {inputFiles.size
                        ? inputFiles.size >= 1000000
                          ? `${(inputFiles.size / 1024 / 1024).toFixed(2)} MB`
                          : inputFiles.size >= 1000
                          ? `${(inputFiles.size / 1024).toFixed(2)} KB`
                          : `${inputFiles.size} bytes`
                        : ""}
                    </p>
                  </div>
                </div>
                <div>
                  <button
                    onClick={() => {
                      setInputFiles([]);
                    }}
                  >
                    <img
                      src={process.env.PUBLIC_URL + "/images/cross.png"}
                      alt="close"
                    />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Fileupload;
